import React from "react";
import { Link } from "react-router-dom";

export const Breadcrumb = ({ menu }) => {
    return (
        <nav>
            <div className="container">
                <ol className="breadcrumb">
                    {menu.map((item) => {
                        return (
                            <li key={item.name} className={`breadcrumb-item ${item.current && "active"}`}>
                                <Link to={item.value}>{item.name}</Link>
                            </li>
                        );
                    })}
                </ol>
            </div>
        </nav>
    );
};
